module.exports = __webpack_public_path__ + "img/sel_pc.b6e1e747.svg";